// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Xqaq","inner":"Footer_inner__2Y3EU"};